import React from 'react';

function MobileLogoComponent(props) {
  const { className } = props;
  return <img alt="convene" className={className} src="/logo.png" />;
}
export default MobileLogoComponent;
